import React from 'react';
import * as MUI from '@mui/material';
import { Controller } from 'react-hook-form';

export const FormTextField = ({
  label,
  name,
  control,
  rules = {},
  defaultValue = '',
  type = 'text',
  size = 'small',
  options,
  ...props
}) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      defaultValue={defaultValue}
      render={({
        field: { ref, value, ...inputProps },
        fieldState: { error },
      }) => (
        <MUI.FormControl fullWidth error={!!error}>
          <MUI.TextField
            value={value ?? ''}
            size={size}
            type={type}
            label={label}
            error={!!error}
            helperText={error?.message}
            inputRef={ref}
            {...inputProps}
            {...props}
          />
        </MUI.FormControl>
      )}
    />
  );
};
